// @ts-nocheck
import React, { useState } from 'react';
import { Dialog, Button, FormGroup, InputGroup } from '@blueprintjs/core';
import { useSelector, useDispatch } from 'react-redux';
import { useCatalogItemSelection } from './CatalogItemSelectionProvider';
import { useCreateCatalogUser } from '@/hooks/query/catalog';
import { useAuthenticatedAccount, useUsers } from '@/hooks/query/users';
import { closeDialog } from '@/store/dashboard/dashboard.actions';

export default function CatalogCredentialsDialog() {
  const dispatch = useDispatch();
  const { provider, providerConfig, credentialsDialogOpen, setCredentialsDialogOpen } = useCatalogItemSelection();
  const [form, setForm] = useState<Record<string, string>>({});
  const [showPassword, setShowPassword] = useState(false);

  const { data: account } = useAuthenticatedAccount();
  const { data: tenantUsers } = useUsers();
  const systemUserId = useSelector((state: any) => state.authentication.userId);

  const tenantUser = tenantUsers?.find(
    (u) => String(u.systemUserId) === String(systemUserId)
  );
  const username = account
    ? `${account.full_name || ''}`.trim()
    : '';

  const { mutate: createUser, isLoading } = useCreateCatalogUser(provider, {
    onSuccess: () => setCredentialsDialogOpen(false),
  });

  const handleChange = (name: string, value: string) =>
    setForm((f) => ({ ...f, [name]: value }));

  const handleSave = () =>
    createUser({ ...form, username: form.loginId, createdBy: tenantUser?.id });

  const handleClose = () => {
    setCredentialsDialogOpen(false);
    dispatch(closeDialog('catalog-item-selection'));
  };
  return (
    <Dialog
      isOpen={credentialsDialogOpen}
      onClose={() => setCredentialsDialogOpen(false)}
      title={`${providerConfig.label} User Details`}
      className="catalog-credentials-dialog"
    >
      <div className="catalog-credentials-dialog__body">
        <div className="catalog-credentials-dialog__grid">
          {providerConfig.credentialFields.map((field) => (
            <FormGroup key={field.name} label={field.label} labelInfo={field.name !== 'username' ? '*' : ''}>
              <InputGroup
                placeholder={field.placeholder}
                type={field.type === 'password' && !showPassword ? 'password' : 'text'}
                value={field.name === 'username' ? username : (form[field.name] || '')}
                readOnly={field.name === 'username'}
                onChange={field.name === 'username' ? undefined : (e) => handleChange(field.name, e.target.value)}
                rightElement={
                  field.type === 'password' ? (
                    <Button
                      minimal
                      icon={showPassword ? 'eye-open' : 'eye-off'}
                      onClick={() => setShowPassword((v) => !v)}
                    />
                  ) : undefined
                }
              />
            </FormGroup>
          ))}
        </div>
        <div className="catalog-credentials-dialog__footer">
          <Button outlined intent="danger" onClick={handleClose}>Cancel</Button>
          <Button intent="primary" loading={isLoading} onClick={handleSave}>Save</Button>
        </div>
      </div>
    </Dialog>
  );
}
